// Persona presets for the Getting Started onboarding flow
// Maps industry + task combinations to relevant data point filters

export interface Industry {
  id: string;
  name: string;
  description: string;
  icon: "building" | "sun" | "factory";
}

export interface Task {
  id: string;
  name: string;
  description: string;
  industryId: string;
}

export interface PersonaPreset {
  industryId: string;
  taskId: string;
  dataPoints: string[];
  tradeGroups: string[];
  description: string;
}

export const INDUSTRIES: Industry[] = [
  {
    id: "residential-builder",
    name: "Residential Homebuilder",
    description: "Single-family and multi-family construction projects",
    icon: "building",
  },
  {
    id: "solar-storage",
    name: "Residential Solar & Storage",
    description: "PV, battery, and energy storage installations",
    icon: "sun",
  },
];

export const TASKS: Task[] = [
  { id: "land-acquisition", name: "Land Acquisition", description: "Site evaluation and feasibility analysis", industryId: "residential-builder" },
  { id: "design", name: "Design", description: "Architectural and engineering requirements", industryId: "residential-builder" },
  { id: "permitting-residential", name: "Permitting", description: "Building permits and approvals process", industryId: "residential-builder" },
  { id: "design-engineering", name: "Design Engineering", description: "System design and structural requirements", industryId: "solar-storage" },
  { id: "permitting-solar", name: "Permitting", description: "Solar permit applications and reviews", industryId: "solar-storage" },
  { id: "interconnection", name: "Interconnection", description: "Utility connection and grid requirements", industryId: "solar-storage" },
  { id: "venue-selection", name: "Venue Selection", description: "Location scouting and venue requirements", industryId: "event-producer" },
  { id: "licensing", name: "Licensing", description: "Entertainment and alcohol licensing", industryId: "event-producer" },
  { id: "operations", name: "Operations", description: "Life safety and operational compliance", industryId: "event-producer" },
];

export const PERSONA_PRESETS: PersonaPreset[] = [];

export function getTasksForIndustry(industryId: string): Task[] {
  return TASKS.filter((task) => task.industryId === industryId);
}

export function getPreset(industryId: string, taskId: string): PersonaPreset | undefined {
  return PERSONA_PRESETS.find(
    (preset) => preset.industryId === industryId && preset.taskId === taskId
  );
}
